import React from 'react';
import { Table, Dropdown } from 'react-bootstrap';

const ListTable = ({
    onEdit,
    onDelete,
    onViewHistory
}) => {
    return (
        <Table responsive className='c-table'>
            <thead>
                <tr>
                    <th>Workflow</th>
                    <th width="80px" className='text-center'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {[...Array(5)].map((_, i) => (
                    <React.Fragment key={i}>
                        <tr>
                            <td>
                                <div className='d-flex align-items-center'>
                                    <div className='c-avatar c-avatar-text'>
                                        D
                                    </div>
                                    <div>
                                        <div className='p-tag fw-bold'>Design Sprint</div>
                                        <div className='p-tag fs-12'>
                                            Backlog <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            To Do <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            In Progress <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            TL Review <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            Reopened <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            PM Review <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            Send to Development <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            Assign to QA <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            Bug Fixing <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            QA Bug Verification <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            Deploy to Beta or Live <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            On Hold <i class="mx-2 fa-solid fa-arrow-right"></i>
                                            Complete
                                        </div>
                                    </div>
                                </div>                            
                            </td>
                            <td className='text-center'>
                                <Dropdown className='c-dropdown-1'>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                        <i className="fas fa-ellipsis-v"></i>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                        <Dropdown.Item onClick={onViewHistory}><i className="fas fa-history me-2"></i> View History</Dropdown.Item>
                                        <Dropdown.Item onClick={onDelete} className="text-danger"><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default ListTable;
